import { getBiasColor, getReliabilityDots } from '@/utils/outlets'

// Bias dot indicator
export function BiasDot({ bias, className = '' }) {
  return (
    <span
      className={`w-2 h-2 rounded-full flex-shrink-0 ${getBiasColor(bias ?? 0)} ${className}`}
      title={`Bias: ${bias?.toFixed(1) ?? 'N/A'}`}
    />
  )
}

// Reliability dots indicator
export function ReliabilityDots({ reliability, inactiveClass = 'bg-muted-foreground/30', className = '' }) {
  const activeDots = getReliabilityDots(reliability ?? 0)

  return (
    <div
      className={`flex gap-0.5 ${className}`}
      title={`Reliability: ${reliability?.toFixed(1) ?? 'N/A'}`}
    >
      {[1, 2, 3, 4].map((dot) => (
        <span
          key={dot}
          className={`w-1.5 h-1.5 rounded-full ${
            dot <= activeDots ? 'bg-green-500' : inactiveClass
          }`}
        />
      ))}
    </div>
  )
}

// Combined bias + reliability indicators
export function OutletIndicators({ outlet, inactiveClass = 'bg-muted-foreground/30' }) {
  return (
    <div className="flex items-center gap-2 flex-shrink-0">
      <BiasDot bias={outlet?.bias} />
      <ReliabilityDots reliability={outlet?.reliability} inactiveClass={inactiveClass} />
    </div>
  )
}
